














import Vue from "vue";
import InputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        InputSelect: InputSelect
    },
    data: function () {
        return {
            pathInStore: "property.constructionPermit.floodZoneType",
        };
    },
    computed: {
        floodZone: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) || "";
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("not_specified"),
                    "value": ""
                },
                {
                    "label": this.$t("recognized_flood_zone"),
                    "value": "RECOGNIZED_FLOOD_ZONE"
                },
                {
                    "label": this.$t("recognized_n_circumscribed_flood_zone"),
                    "value": "RECOGNIZED_N_CIRCUMSCRIBED_FLOOD_ZONE"
                },
                {
                    "label": this.$t("recognized_n_circumscribed_waterside_flood_zone"),
                    "value": "RECOGNIZED_N_CIRCUMSCRIBED_WATERSIDE_FLOOD_ZONE"
                },
                {
                    "label": this.$t("possible_flood_zone"),
                    "value": "POSSIBLE_FLOOD_ZONE"
                },
                {
                    "label": this.$t("possible_n_circumscribed_flood_zone"),
                    "value": "POSSIBLE_N_CIRCUMSCRIBED_FLOOD_ZONE"
                },
                {
                    "label": this.$t("possible_n_circumscribed_waterside_zone"),
                    "value": "POSSIBLE_N_CIRCUMSCRIBED_WATERSIDE_ZONE"
                },
                {
                    "label": this.$t("circumscribed_flood_zone"),
                    "value": "CIRCUMSCRIBED_FLOOD_ZONE"
                },
                {
                    "label": this.$t("circumscribed_waterside_zone"),
                    "value": "CIRCUMSCRIBED_WATERSIDE_ZONE"
                },
                {
                    "label": this.$t("non_flood_zone"),
                    "value": "NON_FLOOD_ZONE"
                },
            ];
        }
    },
    methods: {
        updateValue: function (value: string) {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});

            } else if (value == "" &&
                this.$store.getters["FormModule/getValue"](this.pathInStore) != null
            ) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
        },
    }
});

